"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var usePermission_1 = __importDefault(require("./usePermission"));
function Permission(_a) {
    var children = _a.children, service = _a.service, type = _a.type, field = _a.field;
    var hasPermission = (0, usePermission_1.default)(service, type !== null && type !== void 0 ? type : '*', field !== null && field !== void 0 ? field : '*')[0];
    return react_1.default.createElement(react_1.default.Fragment, null, hasPermission && children);
}
exports.default = Permission;
//# sourceMappingURL=Permission.js.map